(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[554],{

/***/ 62173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ ArticlePublisher; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_dateHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78219);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90664);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var ArticlePublisher = function(param) {
    var author = param.author, publishedDate = param.publishedDate, fontColor = param.fontColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().publish), fontColor && (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[fontColor]),
        children: [
            "Article by ",
            author === null || author === void 0 ? void 0 : author.name,
            " |",
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().date),
                children: (0,_utils_dateHelper__WEBPACK_IMPORTED_MODULE_1__/* .parseAndFormatDate */ .PN)(publishedDate, "DD MMM YYYY")
            })
        ]
    });
};


/***/ }),

/***/ 78868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CmsImage_CmsImage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/CMS/CmsImage/getImageUrl.ts
var getImageUrl = function(imageFormats, smallestImageFormat, fallbackImageUrl) {
    if (!imageFormats) {
        return fallbackImageUrl;
    }
    if (imageFormats[smallestImageFormat]) {
        return imageFormats[smallestImageFormat].url;
    }
    var currentSmallestImageFormat = smallestImageFormat;
    var availableimageFormats = [
        "thumbnail",
        "small",
        "medium",
        "large"
    ];
    while(!imageFormats[currentSmallestImageFormat]){
        if (currentSmallestImageFormat === "large") {
            return fallbackImageUrl;
        }
        currentSmallestImageFormat = availableimageFormats[availableimageFormats.indexOf(currentSmallestImageFormat) + 1];
        if (imageFormats[currentSmallestImageFormat]) {
            return imageFormats[currentSmallestImageFormat].url;
        }
    }
};

;// CONCATENATED MODULE: ./components/CMS/CmsImage/CmsImage.tsx




var CmsImage = function(param) {
    var imageProps = param.imageProps, altText = param.altText, format = param.format, quality = param.quality, layout = param.layout, height = param.height, width = param.width, objectFit = param.objectFit, priority = param.priority, className = param.className, sizes = param.sizes;
    var imageUrl = getImageUrl(imageProps.formats, format, imageProps.url);
    return imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        className: className,
        alt: altText,
        src: imageUrl,
        priority: priority,
        layout: layout,
        objectFit: objectFit,
        quality: quality,
        height: height,
        width: width,
        sizes: sizes
    }) : null;
};
/* harmony default export */ var CmsImage_CmsImage = (CmsImage);

;// CONCATENATED MODULE: ./components/CMS/CmsImage/index.ts



/***/ }),

/***/ 87113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mo": function() { return /* binding */ ImageContainer; },
  "Zp": function() { return /* binding */ defaultAlt; }
});

// UNUSED EXPORTS: RegisterImgStyle

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/SmallPrintTerms/style.module.scss
var style_module = __webpack_require__(10416);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/SmallPrintTerms/index.tsx






var privacyPolicyUrl = appClientConfig/* appClientConfig.privacyPolicyUrl */.p.privacyPolicyUrl;
var SmallPrintTerms = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (style_module_default()).smallPrint,
        children: [
            "Our",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                as: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (style_module_default()).link,
                    href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                    children: "Terms of Use"
                })
            }),
            " ",
            "and",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: privacyPolicyUrl,
                as: privacyPolicyUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (style_module_default()).link,
                    href: privacyPolicyUrl,
                    children: "Privacy Policy"
                })
            })
        ]
    });
};
/* harmony default export */ var components_SmallPrintTerms = (SmallPrintTerms);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
;// CONCATENATED MODULE: ./components/Image/img/quote.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 52,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.79 46c-3.927 0-7.068-1.42-9.424-4.26C1.122 38.789 0 34.984 0 30.327c0-6.36 1.683-12.096 5.049-17.207C8.526 7.894 13.799 3.52 20.867 0l1.851 2.726c-3.365 2.044-6.45 4.94-9.255 8.689-2.693 3.634-4.039 7.326-4.039 11.074 0 1.022.28 1.874.841 2.555.561.568 1.403.852 2.525.852 2.804 0 5.16 1.023 7.068 3.067 2.019 1.93 3.029 4.316 3.029 7.155 0 2.84-1.01 5.225-3.03 7.156C17.95 45.091 15.595 46 12.79 46Zm29.113 0c-3.927 0-7.068-1.42-9.424-4.26-2.244-2.952-3.366-6.757-3.366-11.414 0-6.36 1.683-12.096 5.049-17.207C37.64 7.894 42.912 3.52 49.98 0l1.85 2.726c-3.365 2.044-6.45 4.94-9.255 8.689-2.693 3.634-4.039 7.326-4.039 11.074 0 1.022.28 1.874.842 2.555.56.568 1.402.852 2.524.852 2.805 0 5.16 1.023 7.068 3.067C50.99 30.893 52 33.279 52 36.118c0 2.84-1.01 5.225-3.03 7.156C47.065 45.091 44.709 46 41.904 46Z",
    fill: "#C0E8FF"
  })));
};
/* harmony default export */ var quote = (SvgQuote);
// EXTERNAL MODULE: ./components/Image/style.module.scss
var Image_style_module = __webpack_require__(20027);
var Image_style_module_default = /*#__PURE__*/__webpack_require__.n(Image_style_module);
;// CONCATENATED MODULE: ./components/Image/index.tsx
/* eslint-disable react/jsx-boolean-value */ 







var defaultAlt = "Medrecruit Image";
var convertToArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
var RegisterImgStyle;
(function(RegisterImgStyle) {
    RegisterImgStyle["Img"] = "img";
    RegisterImgStyle["OverlayImage"] = "overlayImage";
})(RegisterImgStyle || (RegisterImgStyle = {}));
var ImageContainer = function(param) {
    var img = param.img, imgStyle = param.imgStyle, imgAlt = param.imgAlt, overlayCenteredText = param.overlayCenteredText, overlayTextInBox = param.overlayTextInBox, width = param.width, height = param.height, whiteBackground = param.whiteBackground;
    var text = overlayCenteredText || overlayTextInBox;
    var textStyle = overlayCenteredText ? (Image_style_module_default()).centeredText : (Image_style_module_default()).overlayCenteredTextInBox;
    var termsStyle = overlayTextInBox ? (Image_style_module_default()).greyText : overlayCenteredText ? (Image_style_module_default()).hidden : (Image_style_module_default()).whiteText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Image_style_module_default()).imgContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(imgStyle === RegisterImgStyle.OverlayImage ? (Image_style_module_default()).overlayImage : (Image_style_module_default()).img),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    priority: true,
                    width: width,
                    height: height,
                    src: img,
                    alt: imgAlt || defaultAlt,
                    title: imgAlt || defaultAlt
                })
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Image_style_module_default()).textContainer, textStyle, whiteBackground && (Image_style_module_default()).whiteBackground),
                children: [
                    overlayTextInBox && /*#__PURE__*/ (0,jsx_runtime.jsx)(quote, {}),
                    convertToArray(text).map(function(text, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: overlayCenteredText ? "h4" : index === 0 ? "subtitle1" : "caption",
                            display: "block",
                            component: "p",
                            children: text
                        }, "".concat(text, "-").concat(index));
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Image_style_module_default()).finePrint, termsStyle, whiteBackground && (Image_style_module_default()).paleBlueText),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SmallPrintTerms, {})
            })
        ]
    });
};


/***/ }),

/***/ 82898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ ProfileBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./modules/LandingHeaderV2/hooks/useUserDisplayInfo.ts
var useUserDisplayInfo = __webpack_require__(43707);
// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
;// CONCATENATED MODULE: ./assets/profileBannerDoctor.png
/* harmony default export */ var profileBannerDoctor = ({"src":"https://cdn.medrecruit.medworld.com/95b4b184d5fb648e624734b6e0d9e33852311df9/_next/static/media/profileBannerDoctor.45cf171f.png","height":404,"width":410,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVMaXESNl+ARiqlbVoEP6N/kLuXteoqVI1jRzqEd4WKXVMGTb89W5hNVHoDWNyqoKpsiL69qafZuKombd2DrvXBtsJxc4uLa2KHcnoXVbi3dE6VVjNja4sDUs6Mi6XE1Pdjl+twEBImAAAAFnRSTlMAGrrsaPz+DGW+08L4/P3++/z+/fBEyeUPCgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAEFJREFUCJljYAABFhZ2MM0kLskNotmZpXhkQTQjlzQvHwMDA4cYq4S4MAMDA6cEGxu/AoghxiokLwKSkhGQExQFAESVAoQENAWMAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie-consent/build/index.js
var build = __webpack_require__(92491);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./components/ProfileBanner/ProfileBanner.module.scss
var ProfileBanner_module = __webpack_require__(38948);
var ProfileBanner_module_default = /*#__PURE__*/__webpack_require__.n(ProfileBanner_module);
;// CONCATENATED MODULE: ./components/ProfileBanner/ProfileBanner.tsx














var ProfileBanner = function(param) {
    var cookieConsentOverwrite = param.cookieConsentOverwrite;
    var ref = (0,react.useState)(false), closed = ref[0], setClosed = ref[1];
    var isDesktop = (0,useMediaQuery/* default */.Z)("(min-width: 768px)");
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var isUserLoggedIn = (0,useUserDisplayInfo/* useUserDisplayInfo */.l)().isUserLoggedIn;
    var _practitionerProfileUrl;
    var profileUrl = (_practitionerProfileUrl = appClientConfig/* appClientConfig.practitionerProfileUrl */.p.practitionerProfileUrl) !== null && _practitionerProfileUrl !== void 0 ? _practitionerProfileUrl : "";
    var consent = cookieConsentOverwrite !== null && cookieConsentOverwrite !== void 0 ? cookieConsentOverwrite : (0,build.getCookieConsentValue)();
    if (consent !== "true" || isUserLoggedIn) {
        return null;
    }
    var VariablePill = function() {
        return isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Top rates,"
                }),
                " negotiated for you"
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Competitive rates"
        });
    };
    var onBannerClose = function() {
        setClosed(true);
        track("Click", {
            action: "Close profile banner",
            "element text": "",
            "element type": "button"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ProfileBanner_module_default()).bannerContainer, closed && (ProfileBanner_module_default()).closed),
        role: "banner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProfileBanner_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: profileBannerDoctor,
                    priority: true,
                    alt: "",
                    "aria-hidden": true,
                    width: 200,
                    height: 200
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (ProfileBanner_module_default()).header,
                        children: "Finding your next job just got easier."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ProfileBanner_module_default()).subHeader,
                        children: "Register to access"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (ProfileBanner_module_default()).benefitsPillsList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Exclusive"
                                    }),
                                    " roles"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VariablePill, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Jobs"
                                    }),
                                    " matched to you"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (ProfileBanner_module_default()).getStartedButton,
                variant: "contained",
                href: "".concat(profileUrl, "/sign-up"),
                onClick: function() {
                    return track("Click", {
                        action: "Profile banner - get started",
                        "element text": "Get started",
                        "element type": "button"
                    });
                },
                children: "Get started"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "close",
                className: (ProfileBanner_module_default()).closeButton,
                onClick: onBannerClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ProfileBanner/index.ts



/***/ }),

/***/ 26877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ ContentHubContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/ProfileBanner/index.ts + 2 modules
var ProfileBanner = __webpack_require__(82898);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tab/Tab.js
var Tab = __webpack_require__(41423);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tabs/Tabs.js + 7 modules
var Tabs = __webpack_require__(57821);
// EXTERNAL MODULE: ./components/CMS/ContentHubMenu/style.module.scss
var style_module = __webpack_require__(50327);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/ContentHubMenu/index.tsx








var ContentHubMenu = function(param) {
    var categories = param.categories, selectedCategorySlug = param.selectedCategorySlug;
    var router = (0,next_router.useRouter)();
    var handleChange = function(event, newValue) {
        router.push("".concat(path/* PATH.ARTICLE_CATEGORY */.m.ARTICLE_CATEGORY, "/").concat(newValue));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (style_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                value: selectedCategorySlug !== null && selectedCategorySlug !== void 0 ? selectedCategorySlug : false,
                onChange: handleChange,
                "aria-label": "article category",
                variant: "scrollable",
                scrollButtons: "auto",
                children: categories.map(function(category) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                        label: category.name,
                        value: category.slug
                    }, category.slug);
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./modules/LandingHeaderV2/index.ts + 19 modules
var LandingHeaderV2 = __webpack_require__(22952);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./modules/Footer/index.ts + 8 modules
var Footer = __webpack_require__(2910);
// EXTERNAL MODULE: ./modules/ContentHubContainer/style.module.scss
var ContentHubContainer_style_module = __webpack_require__(59066);
var ContentHubContainer_style_module_default = /*#__PURE__*/__webpack_require__.n(ContentHubContainer_style_module);
;// CONCATENATED MODULE: ./modules/ContentHubContainer/index.tsx








// import LandingHeader from 'modules/LandingHeader';

var CookieConsentPrompt = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1273).then(__webpack_require__.bind(__webpack_require__, 26871));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26871)
            ];
        }
    }
});
var ContentHubContainer = function(param) {
    var categories = param.categories, _selectedCategorySlug = param.selectedCategorySlug, selectedCategorySlug = _selectedCategorySlug === void 0 ? null : _selectedCategorySlug, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ContentHubContainer_style_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingHeaderV2/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentHubMenu, {
                categories: categories,
                selectedCategorySlug: selectedCategorySlug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieConsentPrompt, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileBanner/* ProfileBanner */.c, {})
        ]
    });
};


/***/ }),

/***/ 78219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L2": function() { return /* binding */ disableWeekends; },
/* harmony export */   "PN": function() { return /* binding */ parseAndFormatDate; },
/* harmony export */   "Zv": function() { return /* binding */ isSameOrBeforeCurrentDate; },
/* harmony export */   "e3": function() { return /* binding */ toIsoDateString; },
/* harmony export */   "i$": function() { return /* binding */ isWeekendDate; },
/* harmony export */   "iT": function() { return /* binding */ saleforceDateFormat; },
/* harmony export */   "qb": function() { return /* binding */ isValidDate; },
/* harmony export */   "sL": function() { return /* binding */ getTomorrow; }
/* harmony export */ });
/* unused harmony export isBeforeNow */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10285);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37412);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2__);

// the customParseFormat is required for strict validation


dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_2___default()));
var isBeforeNow = function(dateTime) {
    var now = dayjs(new Date());
    return dayjs(dateTime).add(1, "day").isBefore(now);
};
var saleforceDateFormat = function(date) {
    return Intl.DateTimeFormat("en-NZ", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    }).format(date);
};
var toIsoDateString = function(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).toISOString();
};
var getTomorrow = function() {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()().add(1, "day");
};
/**
 * Performs a strict date validation against a given format
 * Checks if date is actually a valid one and in the right format
 */ var isValidDate = function(date, format) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date, format, true).isValid();
};
/**
 * Converts an ISO date to given format
 * ! Will try to convert even invalid dates using native 'Date' object rules
 * For example '2022-02-31' will be converted to '2022-03-03'
 */ var parseAndFormatDate = function(dateToParse, format) {
    if (!dateToParse) {
        return null;
    }
    var dayjsDate = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateToParse);
    return dayjsDate.isValid() ? dayjsDate.format(format) : null;
};
//Identify weekends
var disableWeekends = function(date) {
    if (date && (date.getDay() == 0 || date.getDay() === 6)) {
        return true;
    }
    return false;
};
var isSameOrBeforeCurrentDate = function(date) {
    var now = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(new Date());
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).isSameOrBefore(now);
};
var isWeekendDate = function(date) {
    var day = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).day();
    return day === 0 || day === 6;
};


/***/ }),

/***/ 90664:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white":"style_white__ZTILG","publish":"style_publish__MR5PE","date":"style_date__uqaV4"};

/***/ }),

/***/ 50327:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__f5IY_"};

/***/ }),

/***/ 20027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"style_imgContainer__okrSE","img":"style_img__XGlaq","overlayImage":"style_overlayImage__JBqLw","textContainer":"style_textContainer__Amkh2","centeredText":"style_centeredText__2FA7k","overlayCenteredTextInBox":"style_overlayCenteredTextInBox__Fudym","finePrint":"style_finePrint__Jzs6x","whiteText":"style_whiteText__k32cQ","greyText":"style_greyText__NEUAp","hidden":"style_hidden__EqpuW","centeredImg":"style_centeredImg__t2PIR","droplets":"style_droplets__Y3htk","whiteBackground":"style_whiteBackground__ByG1F","paleBlueText":"style_paleBlueText__yr_OJ"};

/***/ }),

/***/ 38948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"ProfileBanner_bannerContainer__kQhdF","closed":"ProfileBanner_closed__qtWy_","imageContainer":"ProfileBanner_imageContainer__VFnDG","header":"ProfileBanner_header__oXcWU","subHeader":"ProfileBanner_subHeader__UqIrm","benefitsPillsList":"ProfileBanner_benefitsPillsList__YVD5X","closeButton":"ProfileBanner_closeButton__O17v8","getStartedButton":"ProfileBanner_getStartedButton__dMz_Q"};

/***/ }),

/***/ 10416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"smallPrint":"style_smallPrint__n1vZC"};

/***/ }),

/***/ 59066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Ed1x1"};

/***/ })

}]);